import type { TtsPlaybackController } from "./useTtsPlaybackController.js";

type PlayFromTarget = Parameters<TtsPlaybackController["playFrom"]>[0];
type PlayFromHandler = (target?: PlayFromTarget) => Promise<void>;

let playFromHandler: PlayFromHandler | null = null;

export function registerTtsPlayFrom(handler: PlayFromHandler | null): void {
  playFromHandler = handler;
}

export async function requestTtsPlayFrom(target?: PlayFromTarget): Promise<boolean> {
  if (!playFromHandler) return false;
  await playFromHandler(target);
  return true;
}
